import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Box } from '@mui/material';

const VisuallyHiddenInput = styled('input')({
	clip: 'rect(0 0 0 0)',
	clipPath: 'inset(50%)',
	height: 1,
	overflow: 'hidden',
	position: 'absolute',
	bottom: 0,
	left: 0,
	whiteSpace: 'nowrap',
	width: 1,
});

interface UploadImageProps {
	onChange: (event: any) => void;
	imageUrl: string | null;
	existingProdImageUrl?: string
}

export default function UploadImage(props: UploadImageProps) {
  	return <Box mt={.25}>
		<Button
			component="label"
			role={undefined}
			variant="contained"
			tabIndex={-1}
			size="small"
			startIcon={<CloudUploadIcon />}
		>
			Upload
			<VisuallyHiddenInput
				accept="image/*"
				type="file"
				onChange={props.onChange}
			/>
		</Button>
		<Box component="span" ml={2}>{(!props.imageUrl && !props.existingProdImageUrl) ? "Click to upload" : props.imageUrl}</Box>
		{props.existingProdImageUrl && <Box component="span" ml={2}>{props.existingProdImageUrl}</Box>}
	</Box>
};
